module.exports = __webpack_public_path__ + "static/media/playstation.82f1d2a4.png";